angular.module('elogbooksFilters').filter('base64', function(base64) {
    return function(input) {
        return base64.encode(input);
    };
});
